(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-start.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-start.js');

'use strict';

const {
  useMemo,
  useEffect
} = React;
const Button = svs.ui.ReactButton;
const {
  trackOnShowDirect,
  trackOnClickStartDraw
} = svs.lyckoplatsen.shared_result;
const {
  useAtom,
  useSetAtom,
  useAtomValue
} = jotai;
const {
  wagersAtom
} = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms;
const {
  showFullscreenAtom,
  correctionStepAtom,
  playCorrectionTlAtom,
  selectedResultAtom,
  correctionTriggerTypeAtom,
  distributionArrayAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  CONSTANTS: {
    CORRECTION_TRIGGER_TYPE,
    CORRECTION_STEP
  },
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
const formatTime = svs.utils.date.FormatTime;
const {
  getCorrectionStartAndTopWinHandler
} = svs.lyckoplatsen.components.shared_map;
const {
  ResultStartSvg
} = svs.lyckoplatsen.components.shared_result.react.components;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const topWinHandler = getCorrectionStartAndTopWinHandler();
const {
  wagerHelper
} = svs.lyckoplatsen.shared_mybets_wager.utils;
const {
  ResultDrawTopWin,
  MapMini
} = svs.lyckoplatsen.components.shared_result.react.components;
const ResultDrawStart = _ref => {
  let {
    setResultDrawStartVisible
  } = _ref;
  const setCorrectionTriggerType = useSetAtom(correctionTriggerTypeAtom);
  const setCorrectionStep = useSetAtom(correctionStepAtom);
  const correctionStep = useAtomValue(correctionStepAtom);
  const [play, setPlay] = useAtom(playCorrectionTlAtom);
  const showFullscreen = useAtomValue(showFullscreenAtom);
  const wagers = useAtomValue(wagersAtom);
  const result = useAtomValue(selectedResultAtom);
  const rawDistributionArray = useAtomValue(distributionArrayAtom);
  const distributionArray = useMemo(() => rawDistributionArray || [], [rawDistributionArray]);
  const showResultClick = () => {
    if (wagers !== null && wagers !== void 0 && wagers.length) {
      var _wagers$0$properties;
      const wins = wagerHelper.getWins(wagers, result);
      const isPrimary = productMapping.isLyckoplatsenPrimary(result.productId);
      const channel = (_wagers$0$properties = wagers[0].properties) === null || _wagers$0$properties === void 0 ? void 0 : _wagers$0$properties.channel;
      const win = wins.reduce((acc, win) => acc + parseFloat(win.amount), 0);
      trackOnShowDirect({
        channel,
        isPrimary,
        win
      });
    }
    setCorrectionStep(CORRECTION_STEP.RESULT);
  };
  const onClickStartDraw = () => {
    if (!showFullscreen) {
      trackOnClickStartDraw();
    }
    if (productMapping.isLyckoplatsenPrimary(result.productId)) {
      topWinHandler.tlTopWinPlay();
    }
    setPlay(true);
    setResultDrawStartVisible === null || setResultDrawStartVisible === void 0 || setResultDrawStartVisible(false);
  };
  if (showFullscreen) {
    setTimeout(() => {
      const startDrawButton = document.querySelector('#start-draw-button'); 
      startDrawButton === null || startDrawButton === void 0 || startDrawButton.click();
    }, 5000);
  }
  useEffect(() => {
    const eventHandlers = {
      automatedStepUpdate: index => {
        setCorrectionTriggerType(CORRECTION_TRIGGER_TYPE.AUTOMATED);
        setCorrectionStep(index);
      }
    };
    topWinHandler.initiateDrawStartAndTopWinExperience(result, distributionArray, isSelfService, eventHandlers);
    return () => {
      topWinHandler.tlTopWinKillAndRemove();
    };
  }, [result, distributionArray, setCorrectionTriggerType, setCorrectionStep]);

  useEffect(() => {
    if (productMapping.isLyckoplatsenSecondary(result.productId)) {
      if (play) {
        topWinHandler.tlTopWinPlay();
      } else {
        topWinHandler.tlTopWinPause();
      }
    }
  }, [play, correctionStep, result.productId]);
  return React.createElement("div", {
    className: "lp-draw-start gsap-draw-start"
  }, React.createElement("div", {
    className: "start-body"
  }, React.createElement("div", {
    className: "lp-header"
  }, formatTime('EEEE d/M yyyy', result.regCloseTime)), React.createElement("div", {
    className: "start-content gsap-draw-start-content"
  }, React.createElement(ResultDrawTopWin, {
    className: "gsap-top-win-start"
  }), wagers && React.createElement("div", {
    className: "start-map"
  }, React.createElement(MapMini, null)), !wagers && productMapping.isLyckoplatsenSecondary(result.productId) && React.createElement("div", {
    className: "start-map"
  }, React.createElement(ResultStartSvg, null)), wagers && React.createElement("div", {
    className: "start-text-wagers"
  }, "Du deltar med ", wagers.length, " ", wagers.length === 1 ? 'plats' : 'platser'), React.createElement("div", {
    className: "start-buttons gsap-start-buttons"
  }, React.createElement(Button, {
    id: "start-draw-button",
    className: "lp-green",
    block: true,
    size: 300,
    onClick: () => onClickStartDraw()
  }, "Starta dragning"), React.createElement(Button, {
    block: true,
    transparent: true,
    inverted: true,
    size: 300,
    onClick: () => showResultClick()
  }, "Visa resultat direkt"))), React.createElement("div", {
    className: "start-content-primary-text gsap-draw-start-primary-text gsap-hide"
  }, "Nu avg\xF6rs hur stor toppvinsten blir!")));
};
setGlobal('svs.lyckoplatsen.components.shared_result.react.components', {
  ResultDrawStart
});

 })(window);